import React, { useEffect, useState, useRef } from 'react'
import cssCulturePointsChineseIdiom from './CulturePointsChineseIdiom.module.scss'
import Card from '../../LUUtils/Card/Card';
import { CardBackgroundEnum } from '../../LUUtils/Card/Card';
import { GoToLUSinceActionEnum } from '../../LearningUnit.js';
import parse from 'html-react-parser'
// import GoogleShareToClassRoom from '../../../Utils/GShare.js'
import CircularProgress from '@material-ui/core/CircularProgress'
import './CulturePointsChineseIdiom.css'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "CulturePointsChineseIdiom"
const IMAGE_DISPLAY_WIDTH = 700
// #endregion Constant

// #region Enumeration
const ScrollButtonEnum = {
    Top: 1,
    More: 2
}
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false // true:第一次進入此Component false:再次render 非第一次進入次Component
let mintTotalPages = 0 // 此LU內 若有Multiple Page 則 在此紀錄共有幾個Page
let mintChangeAnimationType = 0 // 0:window.gChangeAnimationTypeEnum.None, 決定Card動畫是 由左而右 或 由右而左
let mstrLUCatSeqNo = "" // LUType
let mstrBookCatID = ""
let mintStateCurrentPageIndex = 0 // Index of SubCategory, ListOfContent, SuperQuestion or IlluContents
let mstrImagePrefix = "" // For content of SubCategory, ListOfContent, SuperQuestion or IlluContents
let marrContentData = [] // For content of SubCategory, ListOfContent, SuperQuestion or IlluContents
let mintIndexOfContent4PreloadImage = 0 // 在Preload時 指出來目前是指到 marrContentData[mintIndexOfContent4PreloadImage]
let mintIndexOfContentImage4PreloadImage = 0 // 在Preload時 指出來目前是指到 marrContentData[mintIndexOfContent4PreloadImage].ImageList[mintIndexOfContentImage4PreloadImage]
// #endregion Member Variables

function CulturePointsChineseIdiom(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [showScrollButton, setShowScrollButton] = useState(false) // Top/More按鈕是否顯示
    const [scrollButtonType, setScrollButtonType] = useState(ScrollButtonEnum.More) // 要顯示Top或More
    const [currentPageIndex, setCurrentPageIndex] = useState(0)
    const [updateDataTime, setUpdateDataTime] = useState(0)
    // #endregion Init State

    // #region Init Ref
    let mrefScrollArea = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        mblnInitialized = true
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo
        mintTotalPages = props.LUInfo.ListOfContent.length
        console.log("mintTotalPages: ", mintTotalPages)
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        mstrImagePrefix = window.Globals.GetResourcePrefix(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Image)

        // 第一次進入LU時 判斷是用點擊/上一頁/下一頁進來的 而給予不同的<Card />動畫
        switch (props.GoToLUSinceAction)
        {
            case GoToLUSinceActionEnum.Default:
                mintChangeAnimationType = window.gChangeAnimationTypeEnum.None
                console.log("Default.mintTotalPages: ", mintTotalPages)
                setCurrentPageIndex(0)
                break;
            case GoToLUSinceActionEnum.GoPrev:
                mintChangeAnimationType = window.gChangeAnimationTypeEnum.Prev
                console.log("GoPrev.mintTotalPages: ", mintTotalPages)
                setCurrentPageIndex(mintTotalPages - 1)
                break;
            case GoToLUSinceActionEnum.GoNext:
                mintChangeAnimationType = window.gChangeAnimationTypeEnum.Next
                console.log("GoNext.mintTotalPages: ", mintTotalPages)
                setCurrentPageIndex(0)
                break;
            default:
                break;
        }
    }
    // #endregion First Launch

    // #region useEffect

    useEffect(() => {
        mintStateCurrentPageIndex = currentPageIndex
    }, [currentPageIndex])

    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        mrefPaintedMe.current()
        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mblnInitialized = false
            mrefCleanUp.current()
        }
    }, [])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        GlobalLibs.AddWindowOnResizeWindow(WindowOnResizeEventHandler, COMP_NAME)

        // 註冊Multiple Page中的上/下一頁事件
        let objCallbackData = {
            "Action": "InitCalledInfoInMultiPagedLU",
            "NextOnTapHandlerRef": LUNextPageHandler,
            "PrevOnTapHandlerRef": LUPrevPageHandler,
            "CanBePrev": (mintStateCurrentPageIndex > 0), // Multiple Page 非第一頁才為ture 
            "CanBeNext": (mintStateCurrentPageIndex < mintTotalPages - 1) // Multiple Page 非最後一頁才會true
        }
        props.CallbackRef(objCallbackData)

        InitContentDataProcessBegin()
        RegisterLanguageChangeHandler()
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")
        GlobalLibs.RemoveWindowOnResizeWindow(COMP_NAME)
        UnregisterLanguageChangeHandler()
    }
    // #endregion Painted Me

    // #region OnTapHandler
    function ScrollAreaScrollToTopOrMoreOnTapHandler()
    {
        console.log(COMP_NAME + ".ScrollAreaScrollToTopOrMoreOnTapHandler: ")
        if (
            (typeof (mrefScrollArea.current) !== "undefined") &&
            (mrefScrollArea.current !== null)
            )
        {

            let intScrollHeight = mrefScrollArea.current.scrollHeight; // scrollHeight Ref: https://www.w3schools.com/jsref/prop_element_scrollheight.asp
            let intScrollWidth = mrefScrollArea.current.scrollWidth; // scrollWidth
            let intScrollLeft = mrefScrollArea.current.scrollLeft; // scrollLeft
            let intScrollTop = mrefScrollArea.current.scrollTop; // scrollTop

            console.log("intScrollHeight:", intScrollHeight)
            console.log("intScrollWidth:", intScrollWidth)
            console.log("intScrollLeft:", intScrollLeft)
            console.log("intScrollTop:", intScrollTop)

            let intClientHeight = mrefScrollArea.current.clientHeight; // .divScrollArea 的高度 // clientHeight Ref: https://www.w3schools.com/jsref/prop_element_clientheight.asp
            let intClientWidth = mrefScrollArea.current.clientWidth; // clientWidth Ref: 
            let intClientTop = mrefScrollArea.current.clientTop; // clientTop
            let intClientLeft = mrefScrollArea.current.clientLeft; // clientLeft

            console.log("intClientHeight:", intClientHeight)
            console.log("intClientWidth:", intClientWidth)
            console.log("intClientTop:", intClientTop)
            console.log("intClientLeft:", intClientLeft)

            // let intScrollTop = mrefScrollArea.current.scrollTop;
            // let intClientHeight = mrefScrollArea.current.clientHeight;
            // let intScrollHeight = mrefScrollArea.current.scrollHeight;

            // +1 是避免有小數點的誤差
            if (intScrollTop + intClientHeight + 1 >= intScrollHeight)
            {
                console.log("ScrollAreaScrollToTopOrMoreOnTapHandler: Scroll已在最底")
                // 如果現在是在Scroll的最底端 則回到最Top
                // Scroll To Top
                // mrefScrollArea.current.scrollTo({ 
                //     top: 0, 
                //     behavior: "smooth" 
                // });
                GlobalLibs.ExecuteScrollTo(mrefScrollArea.current, 0, 0, 300)
            }
            else
            {
                console.log("ScrollAreaScrollToTopOrMoreOnTapHandler: Scroll未在最底")
                // 如果未到底 就向下移動 (clientHeight / 2) 如果已到最底 則不動
                // Scroll To Somewhere
                let intScrollTo = mrefScrollArea.current.scrollTop + ((intScrollTop + intClientHeight !== intScrollHeight) ? (intClientHeight / 2) : 0)
                // mrefScrollArea.current.scrollTo({ 
                //     top: intScrollTo, 
                //     behavior: "smooth" 
                // });

                GlobalLibs.ExecuteScrollBy(mrefScrollArea.current, intScrollTo, 0, 300)
            }
        }
    }
    // #endregion OnTapHandler

    // #region Other Handler

    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")

        InitContentDataProcessBegin()
    }

    function WindowOnResizeEventHandler()
    {
        console.log(COMP_NAME + ".WindowOnResizeEventHandler")

        SetScrollToTopOrMoreButton()
    }

    // #endregion Other Handler

    // #region Toast
    // #endregion Toast

    // #region LoadingMask and Alert
    // function OpenLoadingMask(LoadingMsg)
    // {
    //     console.log("OpenLoadingMask: ", LoadingMsg)

    //     let objCallbackData = {
    //         "Action": "OpenLoadingMask",
    //         "Message": LoadingMsg
    //     }
    //     props.CallbackRef(objCallbackData)
    // }

    // function CloseLoadingMask()
    // {
    //     console.log(COMP_NAME + ".CloseLoadingMask")

    //     let objCallbackData = {
    //         "Action": "CloseLoadingMask"
    //     }
    //     props.CallbackRef(objCallbackData)
    // }
    // #endregion LoadingMask and Alert

    // #region Component Callback
    function CardCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".CardCallback", CallbackObj)

        if (CallbackObj.Action === "ComponentDidUpdate")
        {
            SetScrollToTopOrMoreButton()
        }
    }
    // #endregion Component Callback

    // #region Alert Callback
    // #endregion Alert Callback

    // #region Other Functions
    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    }

    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/15 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL;
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置
        
        let strQueryString = "Action=" + intAction 
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler

    // #region LU Change page within multiple page
    function LUPrevPageHandler()
    {
        console.log(COMP_NAME + ".LUPrevPageHandler: ")

        console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)
        console.log("mintTotalPages: ", mintTotalPages)

        if (mintStateCurrentPageIndex > 0)
        {
            // 目前在Multiple Page中 的非第一頁 點擊上一頁
            console.log("Prev is clicked, let's go to Prev page")
            mintChangeAnimationType = window.gChangeAnimationTypeEnum.Prev // 動畫新的畫面 由右往左出現
            // mintCurrentPageIndex--
            let intPageIndex = mintStateCurrentPageIndex - 1
            setCurrentPageIndex(intPageIndex)

            let objCallbackData = {
                "Action": "UpdateCanBeNavigatedInMultiPagedLU",
                "CanBePrev": (intPageIndex > 0),
                "CanBeNext": (intPageIndex < mintTotalPages - 1)
            }
            props.CallbackRef(objCallbackData)

            ScrollToTop()
        }
        else
        {
            // richard: 20211110 因為有 CanBeNext, parent 加判斷就不會發生
            // LU內有Multiple Page中 已在第一頁時 點擊上一頁
            console.log("Prev is clicked in the 1st page, let's inform parent")
            console.log("不應該發生")
        }
    }

    function LUNextPageHandler()
    {
        console.log(COMP_NAME + ".LUNextPageHandler: ")

        console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)
        console.log("mintTotalPages: ", mintTotalPages)

        if (mintStateCurrentPageIndex < mintTotalPages - 1)
        {
            // LU內有Multiple Page 在非最後一頁時 點擊下一頁
            console.log("Next is clicked, let's go to next page")
            mintChangeAnimationType = window.gChangeAnimationTypeEnum.Next // 動畫新的畫面 由左往右出現
            // mintCurrentPageIndex++
            let intPageIndex = mintStateCurrentPageIndex + 1
            setCurrentPageIndex(intPageIndex)

            let objCallbackData = {
                "Action": "UpdateCanBeNavigatedInMultiPagedLU",
                "CanBePrev": (intPageIndex > 0),
                "CanBeNext": (intPageIndex < mintTotalPages - 1)
            }
            props.CallbackRef(objCallbackData)

            ScrollToTop()
        }
        else
        {
            // richard: 20211110 因為有 CanBeNext, parent 加判斷就不會發生
            console.log("Next is clicked in the last page, let's inform parent")
            console.log("不應該發生")
        }
    }
    // #endregion LU Change page within multiple page

    function ScrollAreaScrollEventHandler(e)
    {
        console.log(COMP_NAME + ".ScrollAreaScrollEventHandler");

        let elmnt = e.target;

        let intScrollHeight = elmnt.scrollHeight; // scrollHeight Ref: https://www.w3schools.com/jsref/prop_element_scrollheight.asp
        let intScrollWidth = elmnt.scrollWidth; // scrollWidth
        let intScrollLeft = elmnt.scrollLeft; // scrollLeft
        let intScrollTop = elmnt.scrollTop; // scrollTop

        console.log("intScrollHeight:", intScrollHeight)
        console.log("intScrollWidth:", intScrollWidth)
        console.log("intScrollLeft:", intScrollLeft)
        console.log("intScrollTop:", intScrollTop)

        let intClientHeight = elmnt.clientHeight; // .divScrollArea 的高度 // clientHeight Ref: https://www.w3schools.com/jsref/prop_element_clientheight.asp
        let intClientWidth = elmnt.clientWidth; // clientWidth Ref: 
        let intClientTop = elmnt.clientTop; // clientTop
        let intClientLeft = elmnt.clientLeft; // clientLeft

        console.log("intClientHeight:", intClientHeight)
        console.log("intClientWidth:", intClientWidth)
        console.log("intClientTop:", intClientTop)
        console.log("intClientLeft:", intClientLeft)

        if (intScrollTop === 0)
        {
            console.log('Reached scroll div top')
        }

        // +1 是避免有小數點的誤差
        if (intScrollTop + intClientHeight + 1 >= intScrollHeight)
        {
            // 目前到最底 則切換 Top/Down圖示

            console.log('Reached scroll div bottom')
            setScrollButtonType(ScrollButtonEnum.Top)
        }
        else
        {
            setScrollButtonType(ScrollButtonEnum.More)
        }
    }

    // #region Scroll

    function ScrollToTop()
    {
        console.log(COMP_NAME + ".ScrollToTop: ")
        if (
            (typeof (mrefScrollArea.current) !== "undefined") &&
            (mrefScrollArea.current !== null)
            )
        {
            GlobalLibs.ExecuteScrollTo(mrefScrollArea.current, 0, 0, 0) // 回到最Top
        }

        setScrollButtonType(ScrollButtonEnum.More)
    }

    function SetScrollToTopOrMoreButton()
    {
        console.log(COMP_NAME + ".SetScrollToTopOrMoreButton: ");

        if (
            (typeof (mrefScrollArea.current) !== "undefined") &&
            (mrefScrollArea.current !== null)
            )
        {
            console.log("mrefScrollArea.current.scrollHeight: ", mrefScrollArea.current.scrollHeight)
            console.log("mrefScrollArea.current.clientHeight: ", mrefScrollArea.current.clientHeight)
            if (mrefScrollArea.current.scrollHeight === mrefScrollArea.current.clientHeight)
            {
                // 目前無Scroll的效果
                setShowScrollButton(false)
            }
            else
            {
                // 目前有Scroll的效果
                setShowScrollButton(true)
            }
        }
    }

    // #endregion Scroll

    // #region ListOfContent Content 
    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function InitContentDataProcessBegin()
    {
        console.log(COMP_NAME + ".InitContentDataProcessBegin: ")
        console.log("InitContentDataProcessBegin.props.LUInfo: ", props.LUInfo)

        marrContentData = []

        let arrImage = []
        let arrKeywordList = []
        let objContent = null

        /*
        Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
        Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        Step 3. Preload 所有原圖 每讀取完一張原圖 就顯示
        */

        props.LUInfo.ListOfContent.forEach((ContentItem) => {
            // Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
            arrKeywordList = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? ContentItem.ContentHTML.MajorLangKeyword : ContentItem.ContentHTML.MinorLangKeyword
            objContent = window.Globals.CreateContentText(ContentItem.ContentHTML.Text, arrKeywordList, mstrImagePrefix)

            console.log("objContent: ", objContent)
            console.log("arrImage: ", arrImage)

            marrContentData.push(objContent)
        })

        console.log("marrContentData: ", marrContentData)

        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        PreloadThumbnailImageProcessBegin()
    }

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function InitContentDataProcessEnd()
    {
        console.log(COMP_NAME + ".InitContentDataProcessEnd: ")

        // 顯示縮圖後 再去Load大圖
        setUpdateDataTime(new Date().getTime())

        // 等setUpdateDataTime(new Date().getTime())產生玩畫面 出現mrefScrollArea後 再去判斷是否顯示Top/More按鈕
        setTimeout(function ()
        {
            SetScrollToTopOrMoreButton()
        }, 100)

        // Step 3. 讀取 每一張原圖 每讀取完一張就顯示
        PreloadOriginalImageProcessBegin()
    }
    // #endregion ListOfContent Content 


    // #region Preload Original Image

    // Preload原圖流程開始
    function PreloadOriginalImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessBegin: ")
        console.log("marrContentData: ", marrContentData)

        mintIndexOfContent4PreloadImage = 0
        mintIndexOfContentImage4PreloadImage = 0

        if (marrContentData[mintIndexOfContent4PreloadImage].ImageList.length > 0)
        {
            LoadOriginalImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
        else
        {
            LoadNextOriginalImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
    }

    // Preload原圖流程結束
    function PreloadOriginalImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessEnd: ")

        console.log("PreloadOriginalImageProcessEnd.marrContentData: ", marrContentData)
    }

    // Preload原圖
    function LoadOriginalImage(IndexOfContent, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadOriginalImage: ", IndexOfContent, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            OriginalImageLoadedHandler(IndexOfContent, ImgIndex)
        };

        // 原圖
        objImage.src = marrContentData[IndexOfContent].ImageList[ImgIndex].OriginalImageUrl // 原圖
    }

    // 原圖讀取完成後要做的處理
    function OriginalImageLoadedHandler(IndexOfContent, ImgIndex)
    {
        console.log(COMP_NAME + ".OriginalImageLoadedHandler: ", IndexOfContent, ImgIndex)

        // 避免 OriginalImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[IndexOfContent]) !== "undefined") &&
            (marrContentData[IndexOfContent] !== null) &&
            (typeof(marrContentData[IndexOfContent].ImageList) !== "undefined") &&
            (marrContentData[IndexOfContent].ImageList !== null) &&
            (typeof(marrContentData[IndexOfContent].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[IndexOfContent].ImageList[ImgIndex] !== null)
            )
        {
            let strOriginalImageUrl = marrContentData[IndexOfContent].ImageList[ImgIndex].OriginalImageUrl
            console.log("strOriginalImageUrl: ", strOriginalImageUrl)
            let strContentText = marrContentData[IndexOfContent].ContentText
            console.log("strContentText: ", strContentText)
            marrContentData[IndexOfContent].ContentText = window.Globals.ChangeThumbnailImageUrlToOriginalImageUrl(strContentText, ImgIndex, strOriginalImageUrl)

            // 原圖每Load完成一張就顯示
            setUpdateDataTime(new Date().getTime())

            LoadNextOriginalImage(IndexOfContent, ImgIndex)
        }
    }

    // Preload下一張原圖
    function LoadNextOriginalImage(IndexOfContent, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadNextOriginalImage: ", IndexOfContent, ImgIndex)

        if (
            (marrContentData[IndexOfContent].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[IndexOfContent].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintIndexOfContentImage4PreloadImage++
            LoadOriginalImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
        else if (IndexOfContent < (marrContentData.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintIndexOfContent4PreloadImage++
            mintIndexOfContentImage4PreloadImage = 0

            if (marrContentData[mintIndexOfContent4PreloadImage].ImageList.length > 0)
            {
                LoadOriginalImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
            }
            else
            {
                LoadNextOriginalImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
            }
        }
        else
        {
            PreloadOriginalImageProcessEnd()
        }
    }
    // #endregion Preload Original Image

    // #region Preload Thumbnail Image for Image Size

    // Preload縮圖流程開始
    function PreloadThumbnailImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessBegin: ")

        mintIndexOfContent4PreloadImage = 0
        mintIndexOfContentImage4PreloadImage = 0

        if (marrContentData[mintIndexOfContent4PreloadImage].ImageList.length > 0)
        {
            LoadThumbnailImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
        else
        {
            LoadNextThumbnailImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
    }

    // Preload縮圖流程結束
    function PreloadThumbnailImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessEnd: ")

        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        marrContentData.forEach((ContentData) => {
            // 將ContentText內 所有的原圖URL 改成 縮圖URL 並且 在每一張圖上設定style指定高寬
            ContentData.ContentText = window.Globals.ChangeAllImageToThumbnailImageAndSpecifyWithHeight(ContentData.ContentText, ContentData.ImageList)
            console.log("marrContentData PreloadThumbnailImageProcessEnd")
        })

        console.log("marrContentData: ", marrContentData)

        InitContentDataProcessEnd()
    }

    // Preload縮圖
    function LoadThumbnailImage(IndexOfContent, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadThumbnailImage: ", IndexOfContent, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            ThumbnailImageLoadedHandler(IndexOfContent, ImgIndex, this.width, this.height)
        };
        objImage.src = marrContentData[IndexOfContent].ImageList[ImgIndex].ThumbnailImageUrl // Preload 縮圖
    }

    // 縮圖讀取完成後要做的處理
    function ThumbnailImageLoadedHandler(IndexOfContent, ImgIndex, Width, Height)
    {
        console.log(COMP_NAME + ".ThumbnailImageLoadedHandler: ", IndexOfContent, ImgIndex, Width, Height)

        // 避免 ThumbnailImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[IndexOfContent]) !== "undefined") &&
            (marrContentData[IndexOfContent] !== null) &&
            (typeof(marrContentData[IndexOfContent].ImageList) !== "undefined") &&
            (marrContentData[IndexOfContent].ImageList !== null) &&
            (typeof(marrContentData[IndexOfContent].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[IndexOfContent].ImageList[ImgIndex] !== null)
            )
        {
            marrContentData[IndexOfContent].ImageList[ImgIndex].Width = Width
            marrContentData[IndexOfContent].ImageList[ImgIndex].Height = Height

            let intDisplayWidth = IMAGE_DISPLAY_WIDTH

            marrContentData[IndexOfContent].ImageList[ImgIndex].DisplayWidth = intDisplayWidth
            marrContentData[IndexOfContent].ImageList[ImgIndex].DisplayHeight = parseInt(intDisplayWidth / (Width / Height))

            console.log("DisplayHeight: ", parseInt(marrContentData[IndexOfContent].ImageList[ImgIndex].DisplayHeight))

            LoadNextThumbnailImage(IndexOfContent, ImgIndex)
        }
    }

    // Preload下一張縮圖
    function LoadNextThumbnailImage(IndexOfContent, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadNextThumbnailImage: ", IndexOfContent, ImgIndex)

        if (
            (marrContentData[IndexOfContent].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[IndexOfContent].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintIndexOfContentImage4PreloadImage++
            LoadThumbnailImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
        else if (IndexOfContent < (marrContentData.length - 1))
        {
            // ContentData 還沒讀完
            mintIndexOfContent4PreloadImage++
            mintIndexOfContentImage4PreloadImage = 0

            if (marrContentData[mintIndexOfContent4PreloadImage].ImageList.length > 0)
            {
                LoadThumbnailImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
            }
            else
            {
                LoadNextThumbnailImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
            }
        }
        else
        {
            PreloadThumbnailImageProcessEnd()
        }
    }

    // #endregion Preload Thumbnail Image for Image Size


    // #endregion Other Functions

    // #region Get ClassName and Style
    function GetClsPageIcon(Index, CurrentIlluContentsIndex)
    {
        console.log(COMP_NAME + ".GetClsPageIcon");
        console.log("GetTouchAreaCls: Index:", Index)
        console.log("GetTouchAreaCls: CurrentIlluContentsIndex:", CurrentIlluContentsIndex)

        let objCls = cssCulturePointsChineseIdiom.divPageIconUnSelect

        if (Index === CurrentIlluContentsIndex)
        {
            console.log("GetClsPageIcon: divPageIconSelected")
            objCls = cssCulturePointsChineseIdiom.divPageIconSelected
        }

        return objCls
    }

    function GetClsScrollTopOrMoreButton(StateScrollButtonType)
    {
        // console.log(COMP_NAME + ".GetClsScrollTopOrMoreButton");

        let objCls = null

        if (StateScrollButtonType === ScrollButtonEnum.Top)
        {
            objCls = cssCulturePointsChineseIdiom.divScrollAreaScrollButtonTop
        }
        else if (StateScrollButtonType === ScrollButtonEnum.More)
        {
            objCls = cssCulturePointsChineseIdiom.divScrollAreaScrollButtonMore
        }

        return objCls
    }

    // #endregion Get ClassName and Style

    // #region Call App and AppCallback
    // #endregion Call App and AppCallback

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service

    // #region Component
    // #endregion Component

    // #region Render

    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if (intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssCulturePointsChineseIdiom.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }

        return objBlockGoogleClassroomButton
    }

    function RenderHeaderLeftArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderLeftArea");

        let strTitleEN = props.SubSectionDef.Name;
        let strTitleCN = '';
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.MajorName;
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName;
        }

        let strInstruction = ""
        if (
            (typeof (props.LUInfo.Instruction) !== 'undefined') &&
            (props.LUInfo.Instruction !== null) &&
            (props.LUInfo.Instruction !== "")
            )
        {
            strInstruction = props.LUInfo.Instruction;
        }

        return (
            <>
                <div className={cssCulturePointsChineseIdiom.divTitleLeftArea}>
                    {RenderGoogleClassrommButton()}
                    <div className={cssCulturePointsChineseIdiom.divTitleSubArea}>
                        <div className={cssCulturePointsChineseIdiom.divLessonIcon}></div>
                        <div className={cssCulturePointsChineseIdiom.divLUTitleTextEN}>
                            {strTitleEN}
                        </div>
                        <div className={cssCulturePointsChineseIdiom.divDividerBar}></div>
                        <div className={cssCulturePointsChineseIdiom.divLUTitleTextCN}>
                            {strTitleCN}
                        </div>
                    </div>
                </div>
                <div className={cssCulturePointsChineseIdiom.divTitleLeftInstructionArea}>{strInstruction}</div>
            </>
        )
    }

    function RenderPageListOfContentArea(StateCurrentPageIndex)
    {
        console.log(COMP_NAME + ".RenderPageListOfContentArea: ", StateCurrentPageIndex)
        console.log("RenderPageListOfContentArea.marrContentData: ", marrContentData)

        let strContentText = ""
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[StateCurrentPageIndex]) !== "undefined") &&
            (marrContentData[StateCurrentPageIndex] !== null) &&
            (typeof(marrContentData[StateCurrentPageIndex].ContentText) !== "undefined") &&
            (marrContentData[StateCurrentPageIndex].ContentText !== null)
        )
        {
            strContentText = marrContentData[StateCurrentPageIndex].ContentText
        }
        console.log("strContentText: ", strContentText)
        return (
            <>
                {parse(strContentText)}
            </>
        )
    }

    function RenderCardContent(StateCurrentPageIndex)
    {
        console.log(COMP_NAME + ".RenderCardContent")

        let strSubject = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ?
            props.LUInfo.ListOfContent[currentPageIndex].MajorSubject :
            props.LUInfo.ListOfContent[currentPageIndex].MinorSubject
        console.log("strSubject: ", strSubject)

        let objBlock = null
        if(updateDataTime > 0)
        {
            objBlock = (
            <>
                <div className={cssCulturePointsChineseIdiom.divContentTitle}>{strSubject}</div>
                <div className={cssCulturePointsChineseIdiom.divContentText}>{RenderPageListOfContentArea(StateCurrentPageIndex)}</div>
            </>
            )
        }
        else
        {
            // Loading Icon
            objBlock = (
                <div className={cssCulturePointsChineseIdiom.divCircularProgressArea}>
                    {/* Change color and position of CircularProgress? Ref: https://stackoverflow.com/questions/59709633/change-color-and-position-of-circularprogress */}
                    <CircularProgress />
                </div>
            )
        }
        return objBlock

        // let strSubject = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ?
        //                 props.LUInfo.ListOfContent[currentPageIndex].MajorSubject :
        //                 props.LUInfo.ListOfContent[currentPageIndex].MinorSubject
        // console.log("strSubject: ", strSubject)


        // if (props.LUInfo.ListOfContent[currentPageIndex].ContentHTML !== null)
        // {
        //     console.log("props.LUInfo.ListOfContent[currentPageIndex].ContentHTML: ", props.LUInfo.ListOfContent[currentPageIndex].ContentHTML)
        //     let strLangKeyword = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.ListOfContent[currentPageIndex].ContentHTML.MajorLangKeyword : props.LUInfo.ListOfContent[currentPageIndex].ContentHTML.MinorLangKeyword
        //     console.log("strLangKeyword:", strLangKeyword)

        //     console.log("Text:", props.LUInfo.ListOfContent[currentPageIndex].ContentHTML.Text)

        //     let objContent = window.Globals.CreateContentText(props.LUInfo.ListOfContent[currentPageIndex].ContentHTML.Text, strLangKeyword, mstrImagePrefix)
        //     console.log("objContent: ", objContent)

        //     objBlock = 
        //     <>
        //         <div className={cssCulturePointsChineseIdiom.divContentTitle}>{strSubject}</div>
        //         <div className={cssCulturePointsChineseIdiom.divContentText}>{parse(objContent.ContentText)}</div>
        //     </>

        // }

        // return objBlock
    }

    function RenderContentScrollArea()
    {
        // console.log(COMP_NAME + ".RenderContentScrollArea")
        let objBlock = null
        if (props.LUInfo.ListOfContent.length > 1)
        {
            objBlock = (
                <Card
                    CardIndex={currentPageIndex}
                    ChangeAnimationType={mintChangeAnimationType}
                    CallbackRef={CardCallback}
                    CardBackground={CardBackgroundEnum.Default}
                    RenderContent={RenderCardContent(currentPageIndex)}
                />
            )
        }
        else if (props.LUInfo.ListOfContent.length === 1)
        {
            objBlock = RenderCardContent(currentPageIndex)
        }

        return (
            <div ref={mrefScrollArea}
                className={cssCulturePointsChineseIdiom.divScrollArea}
                onScroll={(event) => ScrollAreaScrollEventHandler(event)}>
                {objBlock}
            </div>
        )
    }

    function RenderScrollTopOrMoreButton()
    {
        // console.log(COMP_NAME + ".RenderScrollTopOrMoreButton")
        let objBlock = null
        if (showScrollButton)
        {
            objBlock = (
                <div className={GetClsScrollTopOrMoreButton(scrollButtonType)} onClick={() => ScrollAreaScrollToTopOrMoreOnTapHandler()}></div>
            )
        }
        return objBlock
    }

    function RenderContentArea()
    {
        // console.log(COMP_NAME + ".RenderContentArea: ")
        
        return (
            <div className={cssCulturePointsChineseIdiom.divContentArea}>
                {RenderContentScrollArea()}
                {RenderScrollTopOrMoreButton()}
            </div>
        )
    }

    function RenderPageIconArea()
    {
        // console.log(COMP_NAME + ".RenderPageIconArea")
        let objBlock = null
        if (props.LUInfo.ListOfContent.length > 1)
        {
            objBlock = (
                <div className={cssCulturePointsChineseIdiom.divPageIconArea}>
                    <div className={cssCulturePointsChineseIdiom.divPageIconContainer}>
                        {props.LUInfo.ListOfContent.map((ListOfContentItem, ListOfContentIndex) =>
                            <div key={ListOfContentIndex} className={cssCulturePointsChineseIdiom.divPageIconBlock}>
                                <div className={GetClsPageIcon(ListOfContentIndex, currentPageIndex)}></div>
                            </div>
                        )}
                    </div>
                </div>
            )
        }
        return objBlock
    }

    return (
        <>
            {RenderHeaderLeftArea()}
            {RenderContentArea()}
            {RenderPageIconArea()}
        </>
    )
    // #endregion Render
}
export default CulturePointsChineseIdiom